import httpService from "../httpService";
import utils from "../utils";

export default {
  findAll(form, pageable) {
    let params = utils.merge(form, utils.initPageableParams(pageable));
    return httpService.get(`/hcCongViecTrongTamSearchView`, {params: params});
  },

  // findAllForDonVi(form, pageable) {
  //   let params = utils.merge(form, utils.initPageableParams(pageable));
  //   return httpService.get(`/hcCommandSearchView/findAllForDonVi`, {params: params});
  // }
};



// WEBPACK FOOTER //
// ./src/services/congviectrongtam/hcCVTrongTamSearchViewService.js